/* src/app/customer/components/user-info/user-info.component.scss */
capacitor-google-maps {
  display: inline-block;
  width: 275px;
  height: 400px;
}
.error-message {
  font: normal normal normal 10px/14px Poppins;
  color: #f34b24;
}
.cover-image {
  width: 100%;
  background-color: #ffffff;
  min-height: 180px;
  padding: 20px;
}
.user-profile {
  width: 120px;
  height: 120px;
  border: 2px solid #ffffff;
  border-radius: 50%;
}
.smartdine-form {
  padding: 6px 12px;
}
.smartdine-form ion-item {
  --background: #fbfefc;
  border-radius: 10px;
  margin-bottom: 4px;
  --inner-padding-end: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.smartdine-form ion-item.radio {
  --background: #fff;
}
.smartdine-form ion-item ion-label {
  min-width: 120px;
  font-weight: 600;
  color: var(--ion-color-primary);
  font-size: 14px;
}
.smartdine-form ion-item ion-input,
.smartdine-form ion-item ion-select {
  text-align: right;
}
.smartdine-form .required-star {
  color: var(--ion-color-danger);
  margin-left: 4px;
}
.smartdine-form small.error-text {
  color: var(--ion-color-danger);
  display: block;
  text-align: right;
  font-size: 12px;
  padding: 2px 4px 6px;
}
/*# sourceMappingURL=user-info.component.css.map */
